import { saveAs } from 'file-saver';
import React from 'react';
import injectSheet from 'react-jss';

import { getDocumentOCR } from '~/components/DocumentsViewPage/Document.data';
import ActionsMenu from '~/components/Shared/ActionsMenu/ActionsMenu';
import { showToast } from '~/components/Shared/EcToast/showToast';
import { useIntl } from 'react-intl';
import { getDocumentOriginal } from '~/redux/api/methods/document';
import { ERROR } from '~/types/toast.types';
import { hasOcrContent } from '~/utils/document.utils';

import styles from './SearchResultsItem.styles';
import { canDownloadSearchResultItem } from './utils';

function DownloadResultItemMenu({ document }) {
  const intl = useIntl();
  const { document_handlers } = document;
  const [documentHandler] = document_handlers;
  const { id, document_name, file_type } = documentHandler;

  const displayError = () =>
    showToast(
      ERROR,
      intl.formatMessage(
        {
          id: 'DownloadResultItemMenu.downloadError',
          defaultMessage:
            'Something went wrong with downloading {documentName}',
          description:
            'Error message for failed document download. Example: documentName = "contract.pdf"',
        },
        { documentName: document_name },
      ),
    );

  const handleOnDownloadOriginalClick = () => {
    getDocumentOriginal(id)
      .then((res) => saveAs(res, `${document_name}.${file_type}`))
      .catch(displayError);
  };

  const handleOnDownloadOcrClick = () => {
    getDocumentOCR(id)
      .then((res) =>
        saveAs(res, `${document_name}.${res.type.split('/').pop()}`),
      )
      .catch(displayError);
  };

  const items = [];

  if (hasOcrContent(documentHandler)) {
    items.push({
      content: intl.formatMessage({
        id: 'DownloadResultItemMenu.downloadText',
        defaultMessage: 'Download (Text)',
        description: 'Menu item for downloading OCR text version',
      }),
      onClick: handleOnDownloadOcrClick,
    });
  }

  items.push({
    content: intl.formatMessage({
      id: 'DownloadResultItemMenu.downloadOriginal',
      defaultMessage: 'Download (Original)',
      description: 'Menu item for downloading original document',
    }),
    onClick: handleOnDownloadOriginalClick,
  });

  return canDownloadSearchResultItem(document) ? (
    <ActionsMenu
      align="end"
      title={intl.formatMessage({
        id: 'DownloadResultItemMenu.downloadMenuTitle',
        defaultMessage: 'Download document menu',
        description: 'Title for download document actions menu',
      })}
      items={items}
    />
  ) : null;
}

export default injectSheet(styles)(DownloadResultItemMenu);
